import React from "react";
import "./AnnouncementBar.css";

const AnnouncementBar = () => {
  const items = [
    // Replaced promotional items per request — these run in the same ticker but use different terms
    "New Electronics Arrivals",
    "Secure Payments Enabled",
    "7‑day Easy Returns",
    "24/7 Customer Support",
    "Best Price Guarantee",
  ];

  return (
    <div className="announcement-bar bg-dark text-white small">
      <div className="announcement-track">
        {items.concat(items).map((text, idx) => (
          <span key={idx} className="announcement-pill">
            {text}
          </span>
        ))}
      </div>
    </div>
  );
};

export default AnnouncementBar;
